var html = require('choo/html')

module.exports = function () {
  return html`
    <svg class="Goal-glyph" viewBox="0 0 1000 533">
      <g fill="currentColor" fill-rule="evenodd">
        <path d="M498.3 347.6c-66 0-120-53.7-120-119.8 0-66 54-119.8 120-119.8S618 161.8 618 227.8s-53.7 119.8-119.8 119.8M728.4.4H604c-.8 0-1.5.7-1.5 1.6v41.3c0 1 .7 1.6 1.5 1.6h49.5l-55 54.8C571 78 536.2 65 498.4 65c-89.8 0-162.8 73-162.8 162.8 0 82.7 62 151 141.7 161.4v47.6h-49c-1 0-1.6.7-1.6 1.6v44.2c0 1 .7 1.6 1.6 1.6h49v47c0 .8.7 1.5 1.6 1.5H523c1 0 1.7-.7 1.7-1.6v-46.8h49c.8 0 1.5-.7 1.5-1.5v-44.3c0-1-.7-1.6-1.5-1.6h-49v-48.4C602 375.7 661 308.6 661 227.8c0-34.8-11-67-29.7-93.6l54-54.2v46.2c0 1 .8 1.6 1.7 1.6h41.3c1 0 1.6-.7 1.6-1.5V2c0-1-.8-1.6-1.7-1.6"/>
        <path d="M571.4 178.7H426c-.8 0-1.5.6-1.5 1.4v35.2c0 1 .7 1.5 1.6 1.5h145.5c1 0 1.6-.7 1.6-1.5V180c0-.8-.6-1.4-1.5-1.4m0 62.8H426c-.8 0-1.5.7-1.5 1.5v35c0 1 .7 1.5 1.6 1.5h145.5c1 0 1.6-.7 1.6-1.4v-35c0-1-.6-1.6-1.5-1.6"/>
      </g>
    </svg>
  `
}
